import { FactoryBot } from './factory-bot'

const factory = new FactoryBot()

export {
  factory as FactoryBot
}
